import SDK from '@ulta/sdk/components/Sdk/Sdk';

export default SDK;